import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import imgIsoLogo from "../../../assets/mr-gen-iso-logo.png";
import imgResults from "../../../assets/results-and-recommendations.png";

function LandingResults() {
  return (
    
    <div className="results" id="resultados">
        <div className="results-img">
            <div>
              <img src={imgIsoLogo} width="100%" alt="mr. gen logo"/>
            </div>
          <img src={imgResults} alt="Mr. GEN resultados y recomendaciones" />
        </div>
        <div className="results-texts">
        <h1 className="results-title">¿En qué consisten<br/> los resultados?</h1>
          <p className="results-intro">
          Luego de recibir los resultados  podés navegar en nuestra plataforma  donde proporcionamos una lista de 300 alimentos locales indicando cuales debes evitar, moderar o preferir la hora de planificar tu alimentación.
            <br/><br/>
            <strong>¿Qué información conocemos a partir de cada análisis?</strong>
          </p>
          <div className="results-specs">
            <div>
              <li>RIESGO DE SOBREPESO<br/> U OBESIDAD</li>
              <li>INTOLERANCIA A LA LACTOSA</li>
              <li>INTOLERANCIA AL GLUTEN</li>
              <li>VITAMINAS Y MINERALES</li>
            </div>
            <div>
              <li>METABOLISMO DE <br/>CARBOHIDRATOS Y GRASAS</li>
              <li>METABOLISMO DE LA CAFEÍNA</li>
              <li>METABOLISMO DEL ALCOHOL</li>
              <li>RESPUESTA AL EJERCICIO FÍSICO</li>
            </div>
          </div>
        </div>
        <div className="iso-logo-mobile">
          <img src={imgIsoLogo} alt="mr. gen logo"/>
        </div>
    </div>

    
  );
}

export default LandingResults;